// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"346":"clientes","417":"reportes","835":"organizacion","871":"proveedores","879":"personal"}[chunkId] + "-" + {"346":"7c148df3d0998bc23818","417":"b803dbe1a2f984bd04ab","835":"2b0255dd6dd325f806f3","871":"e9b036bec0cf7249ccb6","879":"1de54855ba104111d08e"}[chunkId] + ".js";
};